import React from 'react'
import { FormGroup, FormControlLabel, Checkbox, Typography, useMediaQuery } from '@mui/material';


const CommonCheckBox = ({ text, value, checked, handleChange, margin, fontSize, checkBoxSize, sx, disabled }) => {
  const md = useMediaQuery('(max-width:900px)');
  return (
    <>
      <FormGroup sx={{ margin: margin ? margin : "0rem" }}>
        <FormControlLabel
          control={<Checkbox value={value} size={checkBoxSize} checked={checked} onChange={handleChange} disabled={disabled}/>}
          label={
            <Typography color="textSecondary" variant="subtitle2" fontSize={fontSize ? fontSize : "14px"} sx={{ ...sx }}>
              {text}
            </Typography>
          }
        />
      </FormGroup>
    </>
  )
}

export default CommonCheckBox;